import ProductVideo from "./ProductVideo";
import { products } from "@/mocks/products";

export default function BeforeAfter() {
  const dish = products[0];

  return (
    <section id="desejo" className="relative overflow-hidden bg-background-50 py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            A diferença
            <span className="h-px w-6 bg-current" />
          </span>
          <h2 className="font-heading text-4xl font-bold leading-[1.08] tracking-tight text-foreground-950 md:text-6xl">
            Seu cardápio informa.
            <br />
            <span className="text-primary-500">O Play Menu desperta desejo.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 items-stretch gap-6 md:mt-20 md:grid-cols-2 md:gap-10">
          {/* LADO ESQUERDO — Cardápio tradicional */}
          <div className="reveal relative overflow-hidden rounded-2xl border border-background-200 bg-background-100 p-4 md:rounded-3xl md:p-6">
            <div className="relative overflow-hidden rounded-xl md:rounded-2xl">
              <div className="aspect-[4/5]">
                <img
                  src="https://static.readdy.ai/image/65821e378a79f8aedcd94a859d1c517b/2281a7e5d37a60064d0732ac50b8e16a.png"
                  alt="Cardápio tradicional em PDF exibido em um tablet"
                  title="Cardápio tradicional — o cliente vê"
                  className="h-full w-full origin-bottom scale-[1.22] object-cover object-top saturate-[0.35] contrast-[0.95]"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-100/40 to-transparent" />
            </div>
            <div className="flex flex-col items-center gap-2 py-5 md:py-7">
              <span className="rounded-full bg-background-200 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-foreground-500">
                Cardápio tradicional
              </span>
              <p className="font-heading text-2xl font-bold text-foreground-400 md:text-3xl">
                O cliente vê.
              </p>
            </div>
          </div>

          {/* LADO DIREITO — Play Menu */}
          <div className="reveal relative overflow-hidden rounded-2xl border border-primary-500/30 bg-foreground-950 p-4 md:rounded-3xl md:p-6" style={{ transitionDelay: "120ms" }}>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,oklch(var(--primary-500)/0.22),transparent_55%)]" />
            <div className="relative overflow-hidden rounded-xl md:rounded-2xl">
              <div className="aspect-[4/5]">
                <ProductVideo src={dish.video} poster={dish.image} alt={dish.name} />
              </div>
            </div>
            <div className="relative flex flex-col items-center gap-2 py-5 md:py-7">
              <span className="rounded-full bg-primary-500 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-foreground-950">
                Play Menu
              </span>
              <p className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
                O cliente deseja.
              </p>
            </div>
          </div>
        </div>

        <p className="reveal mt-10 text-center font-heading text-lg font-semibold text-foreground-700 md:mt-14 md:text-xl">
          A diferença acontece antes mesmo do pedido.
        </p>
      </div>
    </section>
  );
}